import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared/shared.module";

import {LoginDetailsRoutingModule} from './login-details-routing.module';
import {LoginDetailsComponent} from "./login-details.component";
import {MaterialModule} from "../shared/material.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {CoreModule} from "../core/core.module";
import { ValidationMessageComponent } from "./validation-message/validation-message.component";
import {HttpClientModule} from "@angular/common/http";
import {StatusTrackerModule} from "../status-tracker/status-tracker.module";

@NgModule({
  declarations: [LoginDetailsRoutingModule.components, ValidationMessageComponent],
  exports: [
    LoginDetailsComponent
  ],
    imports: [
        CommonModule,
        LoginDetailsRoutingModule,
        SharedModule,
        MaterialModule,
        FlexLayoutModule,
        CoreModule, HttpClientModule, StatusTrackerModule
    ]
})
export class LoginDetailsModule {
}
